"use strict";
/*
 * --------------------------------------------------------------------------------------------------------------------
 * <copyright file="HxRemoveDelegatesArgs.ts" company="Microsoft">
 *   Copyright (c) Microsoft Corporation.  All rights reserved.
 * </copyright>
 * <summary>
 *   !!! This is an automatically generated file for Actor Command Args and serialization helpers !!!
 *   Please run `MakeGenFiles.bat Actors` from the hxcomm/tools/bin
 *   directory to update its contents.
 * </summary>
 * Generating File: CommandArgsJs.tt
 * --------------------------------------------------------------------------------------------------------------------
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.serializeHxRemoveDelegatesArgs = void 0;
function serializeHxRemoveDelegatesArgs(_arg) {
    var output = [];
    var delegateSmtpAddressesOutput = [];
    _arg.delegateSmtpAddresses.forEach(function (item) { return delegateSmtpAddressesOutput.push(item); });
    output.push(delegateSmtpAddressesOutput);
    return output;
}
exports.serializeHxRemoveDelegatesArgs = serializeHxRemoveDelegatesArgs;
